// extracted by mini-css-extract-plugin
export default {"emailTemplateTabs":"styles_emailTemplateTabs__1JpD-","singleTab":"styles_singleTab__G+sZf"};